import { faCalendarCheck } from '@fortawesome/pro-solid-svg-icons'
import type { AvailabilityUpdateEvent } from '~/domains/actions/types'
import { formatDateShort } from '~/utils/date'
import { BaseHistoryCard } from './BaseHistoryCard'
import { HistoryItemContent } from './HistoryItemContent'

export const AvailabilityUpdateHistoryCard = ({
  event
}: {
  event: AvailabilityUpdateEvent
}) => {
  return (
    <BaseHistoryCard
      event={event}
      title={'Mise à jour de la disponibilité'}
      icon={faCalendarCheck}
    >
      {event.scheduledDate && (
        <HistoryItemContent>
          disponibilité confirmée le{' '}
          {formatDateShort(new Date(event.scheduledDate))}
        </HistoryItemContent>
      )}
    </BaseHistoryCard>
  )
}
